import React, { useEffect, useState } from "react";
import Select from "react-select";
import { updateCustomerIndvidual } from "../../api/customers";

const REPORT_STATUS_OPTIONS = [
  { value: "done", label: "Done", color: "#38A169" },
  { value: "wip", label: "WIP", color: "#3182CE" },
  { value: "uncategorized", label: "Uncatz", color: "#DD6B20" },
  { value: "issue", label: "Issue", color: "#E53E3E" },
];

const customStyles = {
  control: (styles) => ({
    ...styles,
    minWidth: 100,
    fontSize: 14,
  }),
  option: (styles, { data, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isSelected ? data.color : isFocused ? "#EDF2F7" : "white",
    color: isSelected ? "white" : "black",
    cursor: "pointer",
  }),
  singleValue: (styles, { data }) => ({
    ...styles,
    color: data.color,
    fontWeight: "bold",
  }),
};

export const ReportStatusSelect = ({ customerId, currentStatus, onUpdate }) => {
  const [selectedOption, setSelectedOption] = useState(
    REPORT_STATUS_OPTIONS.find((opt) => opt.value === currentStatus)
  );

  useEffect(() => {
    const matched = REPORT_STATUS_OPTIONS.find(
      (opt) => opt.value === currentStatus
    );
    setSelectedOption(matched);
  }, [currentStatus]);

  const handleChange = async (option) => {
    setSelectedOption(option);
    try {
      await updateCustomerIndvidual(customerId, {
        report_status: option.value,
      });
      onUpdate?.(option.value);
    } catch (err) {
      console.error("Failed to update report status", err);
    }
  };

  return (
    <Select
      value={selectedOption}
      options={REPORT_STATUS_OPTIONS}
      onChange={handleChange}
      styles={customStyles}
      isSearchable={false}
      menuPlacement="auto"
    />
  );
};
